export const previewBonusPromocodes = () => {
    return [
        {
          promocode_id: "big_bonus_1",
          title: "BIG BONUS 1",
          description: "The maximum bet that can be placed with bonus funds is €20, wins deriving from bets placed above €20 will be subject to a wagering penalty of 10x the excess win.",
          percentage_value: 50,
          constraints: {
            payment_methods: [
                  "Credit Card",
                  "other_method_key_example"
              ],
            processing_currencies: {
              USD: {
                min_amount: 2000,
                max_amount: 4900
                },
                EUR: {
                  min_amount: 1500,
                  max_amount: 4400
                },
                SEK: {
                  min_amount: 20000,
                  max_amount: 49000
                }
            }
          }
        },
        {
          promocode_id: "big_bonus_5",
          title: "BIG BONUS 5",
          description: "Unlock an exclusive shopping experience with our special promo code, designed to give you maximum value every time you shop online. Whether you are searching for the latest fashion trends, essential home products, innovative gadgets, or unique gifts, this promo code ensures that you save more with every order. Simply apply it at checkout to enjoy instant discounts and make your purchases even more rewarding. Our promotion is crafted to enhance your buying journey, making premium quality items more accessible without stretching your budget. Share this opportunity with friends and family so they too can enjoy significant savings. No hidden conditions, no unnecessary restrictions-just straightforward benefits. From limited-time deals to seasonal offers, this code adapts to your needs and helps you take advantage of the best prices available. Don't miss out-redeem the promo today and transform the way you shop by combining quality, convenience, and unbeatable savings in one simple step. Get your bonus NOW!",
          percentage_value: 90,
          constraints: {
            payment_methods: null, // no payment method constraints, available for all payment methods
            processing_currencies: {
              USD: {
                min_amount: 30000,
                max_amount: null // no max amount limitation, available for any amount above min limit
              },
              SEK: {
                min_amount: 300000,
                max_amount: null
              }
            }
          }
        }
      ]
}
